import { Form } from './form.js';
import { Widget } from '../widget/widget.js';
import { ApiClient, ApiClientFactory } from '../api/apiclientfactory.js';
import { ApiResponse } from '../api/api.js';
import { InvalidInputError } from '../errors/invalidInputError.js';

/**
 * handle the special case of a form in the frontend
 */
export class FrontendForm extends Form {
    private readonly formName: string;
    private readonly formId: string;

    /**
     * @param formName - name of the form
     * @param apiClient - instance of an ApiClient
     * @param widgets - available widgets for this form
     * @param formId - id of the form for multi-form support
     */
    constructor(formName: string, apiClient: ApiClient, widgets: Record<string, typeof Widget>, formId:null|string) {
        // calls initWidgets()
        super(null, [], apiClient ?? ApiClientFactory(), widgets, {
            formName,
            formId,
        });
    }

    /**
     * override initWidgets() to set the parent form before selecting all widgets
     * should be backwards compatible due to not caring if such parent form is present
     */
    initWidgets(formNode?: HTMLElement) {
        let parentForm = document.querySelector(`[data-form-id="${this.formId}"]`);
        if (parentForm === null) {
            const forms = document.querySelectorAll(`[data-form-name="${this.formName}"]`);
            if (forms.length === 1) {
                parentForm = forms[0];
            } else if (forms.length > 1) {
                alert(`Multiple forms with name ${this.formName} found.\nPlease add "data-form-id" to the form tags.`)
            }
        }

        if (parentForm !== null) {
            super.initWidgets(parentForm);
        } else {
            super.initWidgets();
        }
    }

    async send(): Promise<InvalidInputError|boolean|ApiResponse> {
        if (await this.validate() === false) {
            return false;
        }

        if (await this.preUploadTasks() === false) {
            return false;
        }

        const values = await this.getValues();

        return this.api.form.send(this.formName, Object.fromEntries(values))
            .catch(this.widgetErrorCatcher.bind(this));
    }
}
